import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Stack } from '@optimus-web/core';
import { PrivilegesField } from './PrivilegesField';
import { PlatformProfilesRole, RoleField } from './RoleField';
import { CommonPlatformProfileFormData, FieldNames } from './commonFormUtils';

export const CommonFormFields = () => {
    const { setValue, watch, getValues } = useFormContext<CommonPlatformProfileFormData>();
    const roleValue = watch(FieldNames.Role);

    useEffect(() => {
        if (roleValue === PlatformProfilesRole.Admin) {
            setValue(FieldNames.Privileges, []);
        }

        if (roleValue === PlatformProfilesRole.Developer) {
            const currentPrivileges = getValues()[FieldNames.Privileges];
            setValue(
                FieldNames.Privileges,
                currentPrivileges.filter((privilege) => privilege !== 'accessAllEnterprises')
            );
        }
    }, [roleValue, setValue, getValues]);

    return (
        <Stack vertical spacing="200">
            <RoleField name={FieldNames.Role} />
            {roleValue !== PlatformProfilesRole.Admin && (
                <PrivilegesField name={FieldNames.Privileges} role={roleValue} />
            )}
        </Stack>
    );
};
